import { UpdateSubsidySettingRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateUpdateSubsidySetting = makeValidator({
  FieldParser: UpdateSubsidySettingRow,
});
